import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Div from "../../../widget/common/ui/Div";
import BranchTeamList from "./widget/BranchTeamList";
import {
  HomeContextImport,
  HomeContextProvider,
} from "../../../provider/home/HomeContextProvider";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import {
  BranchTeamContextImport,
  BranchTeamContextProvider,
} from "../../../provider/branch/branch_team/BranchTeamContextProvider";
import { SearchTeamList } from "../../../model/branch/BranchTeamModel";
import SearchInput from "../../../widget/common/form/SearchInput";
import CacheStorage from "../../../service/storage/CacheStorage";

const BranchTeamContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;
  return isModal ? (
    <HomeContextProvider>
      <BranchTeamContextProvider>
        <BranchTeamMainContent type={type} isModal={isModal} />
      </BranchTeamContextProvider>
    </HomeContextProvider>
  ) : (
    <BranchTeamMainContent type={type} isModal={isModal} />
  );
};
export default BranchTeamContent;

const BranchTeamMainContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  const { getBranchDetail, branchDetail } = HomeContextImport();
  const {
    branchTeamInit,
    onClickTeam,
    handleOnChange,
    clearSearch,
    branchTeamList,
    searchValue,
    showSearch,
  } = BranchTeamContextImport();

  const [branchName, setBranchName] = useState<string>("");
  const [teamList, setTeamList] = useState<Array<SearchTeamList> | null>(null);

  const initData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    if (UtilityHelper.isEmpty(branchNameSession)) {
      getBranchDetail();
    } else {
      setBranchName(branchNameSession);
    }
  };

  useEffect(() => {
    initData();
    branchTeamInit();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTeamList(branchTeamList);
  }, [branchTeamList]);

  useEffect(() => {
    if (branchDetail != null) {
      setBranchName(branchDetail?.title!);
    }
  }, [branchDetail]);

  return (
    <Div className={`${!isModal && "pt-lg-4 pb-5  h-100"}`}>
      {UtilityHelper.isNotEmpty(branchName) && !isModal && showSearch && (
        <>
          <SearchInput
            name="search-branch-team"
            placeHolder="search"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
            listLogic={true}
          />
        </>
      )}

      <>
        {UtilityHelper.isEmpty(branchName) && (
          <Center className="h-100">{Loader.normal()}</Center>
        )}
      </>

      {UtilityHelper.isNotEmpty(branchName) && (
        <BranchTeamList
          teamList={teamList}
          type={type}
          onClickTeam={onClickTeam}
        />
      )}
    </Div>
  );
};
